


























































import {functions} from "@/scripts/firebase";
import { Component, Prop, Watch,Mixins} from 'vue-property-decorator';
import { UserPublicProfile, UserRole, ClassData } from "@/scripts/datatypes";
//import { ValidationObserver } from 'vee-validate'
import Common from '@/mixins/common'
//eslint-disable-next-line
const jaconv = require("jaconv")

interface ExUserPublicProfile extends UserPublicProfile {
  uid: string;
  hidden?: boolean;
} 

type Taxonomy = {
	[key in 'class' | 'group' | 'role']: Term[]
};

interface Term {
  name: string;
  id: string;
  count: number;
}

interface SelectedFilter {
  classId: string;
  groupId: string;
  role: string;
  excludeUids: string[];
  searchText: string;
}

@Component

export default class PanelSelectUser extends Mixins(Common)  {
  @Prop({type: Boolean, default: false}) private isShow?: boolean
  @Prop({type: String, default: ''}) private title?: string
  @Prop({type: Array,default: () => {return []}}) private excludeUids?: string[]
  @Prop({type: Array,default: () => {return []}}) private excludeRoles?: string[]
  @Prop({type: Array,default: () => {return []}}) private includeRoles?: string[]

  htmlElement?: HTMLElement

  isLoading = true

  orderBy: keyof UserPublicProfile = 'creationTime'

  users: ExUserPublicProfile[] = []

  userRolesAccessLevels: UserRole = {}

  cls: ClassData[] = []

  taxonomy: Taxonomy = {
    class: [],
    group: [],
    role: [],
  }

  selectedFilter: SelectedFilter = {
    classId: '',
    groupId: '',
    role: 'student',
    excludeUids: [],
    searchText: '' 
  }

  height = 0

  isLoaded = false

  @Watch('excludeUids')
  updateExcludeUids(newVal: string[]){
    this.selectedFilter.excludeUids = newVal.slice()
  }

  @Watch('isShow')
  updateIsShow(newVal: boolean){
    if(! this.htmlElement){
      this.$emit("onSelect", false);
      return
    }

    if(newVal){
      if(this.isLoaded){
        this.htmlElement.style.cssText = 'height:' + this.height + 'px; visibility: visible; position: static; opacity: 1; transition: all 0.5s;'
      }
    }else{
      this.htmlElement.style.cssText = 'height:0; visibility: hidden; position: absolute; opacity: 0; transition: all 0.3s;'
    }
  }

  get roles(): string[]{
    const roles = Object.keys(this.userRolesAccessLevels)
    return roles
  }

  setFilterOnUsersData(filter: SelectedFilter){
    const searchText = jaconv.toHiragana(jaconv.toZen(filter.searchText)) as string

    const settingFilter = !! (filter.classId || filter.groupId || filter.excludeUids || filter.role || filter.searchText)

    this.users = this.users.map(user => {
      user.hidden = false

      if(filter.excludeUids.length > 0 && filter.excludeUids.includes(user.uid)){
        user.hidden = true
        return user
      }

      if(! settingFilter){
        return user
      }

      if(searchText && ! this.$findTextByUserProfile(searchText, user)){
        user.hidden = true
        return user
      }

      if(filter.classId && ! this.cls.some((cl)=>{return cl.classId === filter.classId && user.uid && cl.memberUids && cl.memberUids.includes(user.uid)})){
        user.hidden = true
        return user
      }

      if(filter.role && user.role !== filter.role){
        user.hidden = true
        return user
      }

      return user
    })

    this.$nextTick(()=>{
      if(this.htmlElement){
        this.height = this.htmlElement.clientHeight
        this.htmlElement.style.height = 'auto'
        this.isLoaded = true
      }
    })
  }

  @Watch('selectedFilter',{deep: true})
  changeSelectedFilter(newVal: SelectedFilter){
    this.setFilterOnUsersData(newVal)
  }

  setTaxonomies(){
    this.taxonomy.role = Object.keys(this.userRolesAccessLevels).map((role) => {
      return {name: role, id: role, count: 0}
    })

    this.taxonomy.class = this.cls.map((cl) => {
      return {name: cl.name, id: cl.classId || '', count: 0}
    })

    this.users.forEach(user => {
      if(user.role){
        this.setTaxonomy(this.taxonomy.role ,user.role)
      }
    })
    this.taxonomy.role = this.taxonomy.role.filter((term)=>{
      if(this.selectedFilter.role === term.name && term.count === 0){
        this.selectedFilter.role = ''
      }
      return term.count > 0
    })
  }

  setTaxonomy(type: Term[], name: string, id = ''){
    if(! name){
      return
    }

    const findIndex = type.findIndex((term) => {
      if(id !== ''){
        return term.id === id && term.name === name
      }
      return term.name === name
    })

    const term: Term = {
      name: name,
      count: 1,
      id: id
    }

    if(findIndex === -1){
      type.push(term)
    }else{
      term.count = 1 + type[findIndex].count
      type.splice(findIndex, 1,term)
    }
  }

  async created(){
    try{
      const usersCol = await this.$getUsersPublicProfileQuery().where('deleted', '==',false).where('disabled', '==',false).orderBy(this.orderBy).get()

      let users = usersCol.docs.map((doc) => {
        return {...doc.data(),hidden: true} as ExUserPublicProfile
      });

      if(this.excludeRoles && this.excludeRoles.length > 0){
        users = users.filter((user) => {return user.role && ! (this.excludeRoles?.includes(user.role) === true)})
      }else if(this.includeRoles && this.includeRoles.length > 0){
        users = users.filter((user) => {return user.role && this.includeRoles?.includes(user.role) === true})
      }

      this.users = users

      const getUserRolesAccessLevels = async (schoolId: string) => {
        const http = functions.httpsCallable('getUserRolesAccessLevels')
        const accessLevels = await http({schoolId: schoolId})
        if(accessLevels.data){
          this.userRolesAccessLevels = accessLevels.data
        }
        return Promise.resolve(true)
      }

      const getClasses = async () => {
        const classRef = (this.$isStaff()) ? this.$getClassesColRef().where('deleted','==',false).where('disabled','==',false) : this.$getUserClassesQuery()

        const classData = await classRef.get()
        
        this.cls = classData.docs.map((doc) => {
            const row = doc.data()
            return {classId: doc.id,...row} as ClassData
        });
        return Promise.resolve(true)
      }

      await Promise.all([getUserRolesAccessLevels(this.$store.getters.schoolId),getClasses()])

      this.setTaxonomies()
      this.setFilterOnUsersData(this.selectedFilter)

    }catch(error){
      //console.table(error)
    }finally{
      this.isLoading = false
    }
  }

  mounted(){
    this.htmlElement = this.$el as HTMLElement
    if(! this.isLoaded && this.isShow){
      this.htmlElement.style.cssText = 'height:auto; visibility: visible; position: static; opacity: 1;'
    }
  }

  public selectUser(user: ExUserPublicProfile): void{
    delete user.hidden
    this.$emit("onSelect", user);
  }

}
